<template>
  <img class="wave-bg" src="https://ibliss-icons-prod.s3.us-east-1.amazonaws.com/label/barra-login.svg" />
  </template>
  
  <script>
  export default {
  name: "welcomeComponent",
  data() {
  return {};
  },
  };
  </script>
  
  <style lang="css" scoped>
  
  body {
  font-family: 'Nunito Sans', sans-serif;
  }
  
  .wave-bg {
  position: relative;
  height: 100vh;
  }
  
  .brand-bg {
  position: absolute;
  left: -350px;
  width: 80%;
  height: 90%;
  }
  
  @media screen and (max-width: 600px) {
    .welcome{
    display:none;
  }
  .col-sm-4{
    flex: 0 0 33.3333333333%;
    max-width: 70.333333%;
  }
  }
  @media screen and (min-width: 600px){
    .col-sm-4 {
      flex: 0 0 33.3333333333%;
      max-width: 70.333333%;
    }
  }

  @media screen and (max-width: 853px) {
    .wave-bg {
      display: none !important;
    }
  }

  @media screen and (max-width: 768px) {
    .wave-bg {
      width: 80%;  /* Reduce el tamaño, ajusta según necesidad */
      height: auto;
    }
  }
  
  @media screen and (max-width: 768px) {

    .col-md-8 {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin-bottom: none; 
      margin-top: none; 
      font-size: 21px;
      color: #6E17A5;
    }
  
    .v-form{
    flex: 0 0 33.3333333333%;
    max-width: 70.333333%;
    }

  }

</style>
  